import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wechat-login" }
const _hoisted_2 = ["src"]

import { onMounted, onBeforeUnmount, ref } from "vue";
import { startQrLogin, QrLoginUser } from "@/utils/qrLogin";


export default /*@__PURE__*/_defineComponent({
  __name: 'WechatLogin',
  props: {
    onSuccess: { type: Function }
  },
  setup(__props: any) {

const props = __props;
const image = ref("");
const error = ref("");
let stop: (() => void) | undefined;
const refresh = () => {
  stop?.();
  image.value = "";
  error.value = "";
  stop = startQrLogin("portal", {
    onReady: (code) => {
      image.value = code.qr_image;
    },
    onSuccess: props.onSuccess,
    onError: (detail) => {
      image.value = "";
      error.value = detail;
    },
  });
};
onMounted(refresh);
onBeforeUnmount(() => stop?.());

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (error.value)
      ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 0,
          type: "warning",
          "show-icon": "",
          message: error.value
        }, null, 8, ["message"]))
      : (image.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: image.value,
            width: "240",
            height: "240",
            alt: "微信扫码登录教师／学生网站"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createBlock(_component_a_spin, {
            key: 2,
            tip: "正在获取登录码"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "placeholder" }, null, -1)
            ]))]),
            _: 1
          })),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "使用微信扫一扫，在小程序中确认登录。", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", null, "首次使用需绑定教师或学生平台账号。", -1)),
    _createVNode(_component_a_button, { onClick: refresh }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("刷新二维码", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})